window.cookies = require('vue-cookies');

// set secure, only https works
window.cookies.config('30d', '/', '.' + process.env.VUE_APP_DOMAIN, true);

export default window.cookies;
